import Dialog from "@/molecules/dialog";
import { styles } from "./style";
import TermsContent from "../../molecules/termsContent";

interface TermsOfServiceDialogProps {
  open: boolean;
  onClose: () => void;
}

export default function TermsOfServiceDialog({
  open,
  onClose,
}: TermsOfServiceDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Mondomixer IoT Cloud 利用規約"
      contentChildren={<TermsContent />}
      PaperProps={{
        sx: styles.paper,
      }}
      BackdropProps={{
        sx: styles.backdrop,
      }}
    />
  );
}
